module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/requisition.b1c9c3f1.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/requisition.png
// module id = 3748
// module chunks = 11